import ArticleMain from './ArticleMain'

export default ArticleMain